import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GoldMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GOLD_MINE;
}

export default GoldMineBuildingTileEntity;
